// Sticky banner shown when an admin is viewing the app AS another user
// (read-only impersonation). Makes the state obvious and offers a one-tap exit.
// docs/replan-v2.md (admin console) / CLAUDE.md §9.

import { Button } from '@fajrarabi/ui';

import { useAuth, stopImpersonating } from '~/lib/auth';

export function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  if (!user?.impersonating) return null;

  const who = user.displayName ?? user.email ?? user.username ?? 'this user';

  async function stop() {
    await stopImpersonating();
    // The cookie is cleared server-side; reload lands on the sign-in gate.
    await refresh();
    window.location.reload();
  }

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-heart px-4 py-2 text-cream-50">
      <span className="text-sm font-semibold">👁 Viewing as {who} — read-only impersonation</span>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => void stop()}
        className="bg-cream-50 text-heart hover:bg-cream-100"
      >
        Stop
      </Button>
    </div>
  );
}
